import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngTinyMce } from '../../inputs';

@Component({
  selector: 'ing-child-item',
  templateUrl: './child-item.component.html',
  styleUrls: ['./child-item.component.scss']
})
export class ChildItemComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngTinyMce;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-child-item';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/child-item/child-item.component.ts